import type { ActionHandler } from '../types'

async function adjustBloodloss(ctx: { characterId: string; supabase: import('@supabase/supabase-js').SupabaseClient }, delta: number) {
  const { data: char } = await ctx.supabase
    .from('characters')
    .select('bloodloss_points')
    .eq('id', ctx.characterId)
    .single()

  if (!char) throw new Error('Character not found')

  const oldVal = char.bloodloss_points
  const newVal = Math.max(0, oldVal + delta)

  const { error } = await ctx.supabase
    .from('characters')
    .update({ bloodloss_points: newVal })
    .eq('id', ctx.characterId)

  if (error) throw error

  return {
    effects: [{
      character_id: ctx.characterId,
      target_table: 'characters',
      target_row_id: ctx.characterId,
      target_field: 'bloodloss_points',
      operation: 'UPDATE' as const,
      old_value: oldVal,
      new_value: newVal,
    }],
    label: delta > 0 ? `+${delta} bloodloss (now ${newVal})` : `−${Math.abs(delta)} bloodloss (now ${newVal})`,
  }
}

export const handleAddBloodloss: ActionHandler<'ADD_BLOODLOSS'> = (ctx, payload) =>
  adjustBloodloss(ctx, payload.amount)

export const handleReduceBloodloss: ActionHandler<'REDUCE_BLOODLOSS'> = (ctx, payload) =>
  adjustBloodloss(ctx, -payload.amount)
